import React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { AppBar } from 'react-toolbox/lib/app_bar';
import theme from './HeaderAppBar.scss';
import entityIds from 'common/tests/entity/entityIds.json';

const DefaultLeft = ({ leftHeader }) => {
    return leftHeader ? leftHeader : null;
};
const DefaultRight = ({ rightHeader, actions, theme }) => {
    // can't use actions when not using default header, good enough tradeoff
    return actions || rightHeader ? (
        <div className={theme.rightHeader}>
            {actions ? <span className={theme.actions}>{actions}</span> : null}
            {rightHeader ? rightHeader : null}
        </div>
    ) : null;
};
const headerAppBarFactory = ({ Left = DefaultLeft, Right = DefaultRight }) => {
    class HeaderAppBar extends React.Component {
        render() {
            const {
                title,
                subtitle,
                theme,
                leftHeader,
                rightHeader,
                middleHeader,
                actions,
                className,
                headerColor,
                ...others
            } = this.props;
            return (
                <AppBar
                    theme={theme}
                    flat
                    className={classnames(className, {
                        [theme[headerColor]]: theme[headerColor] ? true : false
                    })}
                >
                    <div className={theme.leftHeader}>
                        {title ? (
                            <span
                                className={theme.title}
                                testId={entityIds.dialog.title}
                            >
                                {title}
                            </span>
                        ) : null}
                        {subtitle ? (
                            <span className={theme.subtitle}>{subtitle}</span>
                        ) : null}
                        <Left
                            leftHeader={leftHeader}
                            theme={theme}
                            actions={actions}
                            {...others}
                        />
                    </div>
                    {middleHeader ? middleHeader : null}
                    <Right
                        rightHeader={rightHeader}
                        actions={actions}
                        theme={theme}
                        {...others}
                    />
                    {this.props.children}
                </AppBar>
            );
        }
    }
    return themr('HeaderAppBar', theme)(HeaderAppBar);
};

const ThemedHeaderAppBar = headerAppBarFactory({});

export default ThemedHeaderAppBar;
export { ThemedHeaderAppBar as HeaderAppBar, headerAppBarFactory };
